import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Successschology() {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="success-schology challenges-rise-up p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="mb-4 mb-md-0">
            <h2 style={{ color: "#111322" }}>
              Navigating Obstacles: The{" "}
              <span className="text-rise-yellow">Key Challenges</span> TekRevol
              Overcame
            </h2>
            <Link
              to="/contact"
              className="border_btn rise-up-btn"
              aria-label="TekRevol Contact"
            >
              Join the Rise Up Kings Community
            </Link>

            {videoLoaded ? (
              <StaticImage
                src="../../../images/case-studies/rise-up-king/key-challenges-before.webp"
                alt="TekRevol"
                layout="constrained"
                className="mt-4 mt-md-5"
                placeholder="blurred"
                formats={["webp"]}
                width={826}
                height={833}
              />
            ) : (
              <StaticImage
                src="../../../images/case-studies/rise-up-king/key-challenges.webp"
                alt="TekRevol"
                layout="constrained"
                className="mt-4 mt-md-5"
                placeholder="blurred"
                formats={["webp"]}
                width={3302}
                height={3327}
              />
            )}
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
            <div className="success-scroll">
              <div className="success-box">
                <div className="num">01</div>
                <h5>Engagement and Retention</h5>
                <p>
                  Keeping users consistently engaged with the platform through
                  ongoing challenges, content, and gamified features.
                </p>
              </div>
              <div className="success-box">
                <div className="num">02</div>
                <h5>Customization & Scalability</h5>
                <p>
                  Building a scalable solution that could accommodate the
                  growing user base while offering personalized experiences for
                  each individual.
                </p>
              </div>
              <div className="success-box">
                <div className="num">03</div>
                <h5>Payment and Subscription Integration</h5>
                <p>
                  Implementing a seamless subscription model with tiered access
                  to exclusive content and resources.
                </p>
              </div>
              <div className="success-box">
                <div className="num">04</div>
                <h5>Community Management</h5>
                <p>
                  Creating effective ways for users to connect, communicate, and
                  build meaningful relationships within a large community
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Successschology;
